import React from "react";

interface BookmarkIconProps {
  onClick?: (event?: unknown) => void;
  isBookmarked?: boolean;
}

export const BookmarkIcon = ({ onClick, isBookmarked }: BookmarkIconProps) => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    {isBookmarked ? (
      <>
        <path
          d="M6.25725 11.0713C6.09891 10.9762 5.90109 10.9762 5.74275 11.0713L1.5 13.6169V1.20711L1.70711 1H10.5V13.6169L6.25725 11.0713Z"
          fill="black"
          stroke="black"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 0C10.9167 0 11.2708 0.145833 11.5625 0.4375C11.8542 0.729167 12 1.08333 12 1.5V16L6 12.5L0 16V1.5C0 1.08333 0.145833 0.729167 0.4375 0.4375C0.729167 0.145833 1.08333 0 1.5 0H10.5ZM11 14.25V1.5C11 1.35417 10.9479 1.23958 10.8438 1.15625C10.7604 1.05208 10.6458 1 10.5 1H1.5C1.35417 1 1.22917 1.05208 1.125 1.15625C1.04167 1.23958 1 1.35417 1 1.5V14.25L6 11.3438L11 14.25Z"
          fill="black"
        />
      </>
    ) : (
      <path
        d="M10.5 0C10.9167 0 11.2708 0.145833 11.5625 0.4375C11.8542 0.729167 12 1.08333 12 1.5V16L6 12.5L0 16V1.5C0 1.08333 0.145833 0.729167 0.4375 0.4375C0.729167 0.145833 1.08333 0 1.5 0H10.5ZM11 14.25V1.5C11 1.35417 10.9479 1.23958 10.8438 1.15625C10.7604 1.05208 10.6458 1 10.5 1H1.5C1.35417 1 1.22917 1.05208 1.125 1.15625C1.04167 1.23958 1 1.35417 1 1.5V14.25L6 11.3438L11 14.25Z"
        fill="black"
      />
    )}
  </svg>
);

BookmarkIcon.defaultProps = {
  onClick: undefined,
  isBookmarked: false,
};
